import { BonusCategoriesTranslations } from "./bonus-categories-pt-br";

export const BONUS_CATEGORIES_ES_ES: BonusCategoriesTranslations = {
	title: "Categorías de Bonificación",
	notification: {
		create: "Categoría de bonificación creada exitosamente",
		edit: "Categoría de bonificación editada exitosamente",
		changeStatus: "Categoría de bonificación modificada exitosamente",
		delete: "Categoría de bonificación eliminada exitosamente",
	},
	delete: {
		title: "Eliminar Categoría de Bonificación",
		subtitle: "¿Está seguro que desea eliminar esta categoría de bonificación?",
		confirm: "Sí, eliminar",
		cancel: "Cancelar",
	},
	header: {
		create: "Nueva Categoría de Bonificación",
		edit: "Editar Categoría de Bonificación",
		search: "Buscar...",
		changeStatus: "Cambiar Estado",
		delete: "Eliminar Categoría",
	},
	list: {
		title: "Categorías de bonificación",
		emptyState: {
			title: "No se encontró ninguna categoría de bonificación",
			description: "Crea una nueva categoría de bonificación para comenzar",
		},
		status: {
			label: "Estado",
			active: "Activo",
			inactive: "Inactivo",
		},
		category: "Categoría",
		productsCategories: "Categorías de Productos",
		products: "Productos",
		isLockZigTag: {
			label: "Uso en la tarjeta",
			tooltip:
				"Cuando está activo, la tarjeta cashless funcionará solo con el saldo de\nbonificación de esta categoría, bloqueando otros saldos y bonificaciones de categorías diferentes.",
			active: "Solo este bono",
			inactive: "Bonos y recargas",
		},
		employees: "Autorizados",
		daysToExpire: "Vencimiento",
		days: "días",
		trash: "Eliminar",
		options: {
			label: "Aciones",
			edit: "Editar Categoría",
			inactive: "Desactivar Categoría",
			active: "Activar Categoría",
		},
	},
	form: {
		name: {
			label: "Nombre de la categoría",
			required: "El nombre es obligatorio",
			placeholder: "Ingrese el nombre de la categoría",
			maxLength: "Máximo 30 caracteres",
		},
		daysToExpire: {
			label: "Validez de la bonificación",
			required: "Campo obligatorio",
			placeholder: "Días",
			positive: "El número de días debe ser positivo",
			maxValue: "Máximo 365 días",
		},
		employees: {
			label: "Empleados autorizados",
			placeholder: "Seleccionar empleados",
			validation: "Seleccione al menos un empleado",
		},
		categories: {
			label: "Categorías que podrán consumir con el bono",
			placeholder: "Seleccionar categorías",
			tooltip: "A limitação será aplicada somente na operação pré-paga",
		},
		products: {
			label: "Productos que podrán ser comprados con el bono",
			placeholder: "Seleccionar productos",
			tooltip: "A limitação será aplicada somente na operação pré-paga",
		},
		lockZigTag: {
			label: "No permite ningún otro tipo de saldo en la tarjeta",
			tooltip:
				"Cuando está activo, la tarjeta cashless funcionará solo con el saldo de\nbonificación de esta categoría, bloqueando otros saldos y bonificaciones de categorías diferentes.",
		},
	},
};
